import { MarketingMessage } from "@app/core/marketing/domain/marketing-message";
import { Observable } from "rxjs";

/*
 * Repository used to get marketing message.
 */
export abstract class MarketingMessageRepo {
  /*
   * Get marketing message.
   * @param token User token.
   * @returns Marketing message.
   */
  abstract getMarketingMessage(token: string): Observable<MarketingMessage>;

  /*
   * Get every active banner (personal + marketing) for the user.
   * Falls back to the singular endpoint when the plural one fails.
   */
  abstract getAllMessagesAndBanners(
    token: string
  ): Observable<MarketingMessage[]>;

  /*
    * Dismiss marketing message.
    * @param token User token.
    * @param marketingId Marketing message id.
    * @param type Marketing message type.
  */
  abstract dismissMarketingMessage(token: string, marketingId: string, type: 'personal' | 'marketing'): Observable<void>;
}